import { Button } from "@progress/kendo-react-buttons";
import { SvgIcon } from "@progress/kendo-react-common";
import { Card, CardBody } from "@progress/kendo-react-layout";
import { arrowRightIcon, chartColumnClusteredIcon, checkCircleIcon, playIcon, saveIcon } from "@progress/kendo-svg-icons";
import { useNavigate } from "react-router-dom";

const workflowSteps = [
    {
        label: "Simulator",
        icon: playIcon,
        backgroundColor: "#e4e7eb",
        color: "#4b5563"
    },
    {
        label: "Save",
        icon: saveIcon,
        backgroundColor: "#e4e7eb",
        color: "#4b5563"
    },
    {
        label: "Compare",
        icon: chartColumnClusteredIcon,
        backgroundColor: "#d1fae5",
        color: "#047857"
    },
    {
        label: "Decision",
        icon: checkCircleIcon,
        backgroundColor: "#1f9d6d",
        color: "#ffffff"
    }
];

const EmptyScenarios: React.FC = () => {
    const navigate = useNavigate();

    const handleGoToSimulator = (): void => {
        navigate("/app/workspace/simulator");
    };

    return (
        <div className="container-fluid h-100 bg-body-tertiary px-3 px-lg-4 py-4 overflow-auto">
            <header className="mb-5">
                <h1 className="h3 fw-bold mb-2 text-body">Scenarios</h1>
                <p className="mb-0 text-body-secondary">Compare and evaluate commercial strategies generated in Simulator.</p>
            </header>

            <Card
                className="mx-auto rounded-4 border border-secondary-subtle shadow-sm bg-white"
                style={{ maxWidth: "896px" }}
            >
                <CardBody className="px-4 px-md-5 py-5">
                    <div className="d-flex flex-column align-items-center text-center">
                        <div className="d-flex align-items-start justify-content-center flex-wrap gap-3 gap-sm-4 mb-5">
                            {workflowSteps.map((step, index) => (
                                <div className="d-flex align-items-start gap-3 gap-sm-4" key={step.label}>
                                    <div className="d-flex flex-column align-items-center gap-3">
                                        <span
                                            className="d-inline-flex align-items-center justify-content-center rounded-4"
                                            style={{
                                                width: "64px",
                                                height: "64px",
                                                backgroundColor: step.backgroundColor,
                                                color: step.color
                                            }}
                                        >
                                            <SvgIcon icon={step.icon} style={{ width: "32px", height: "32px" }} />
                                        </span>
                                        <span className="small fw-bold text-body">{step.label}</span>
                                    </div>
                                    {index < workflowSteps.length - 1 && (
                                        <span className="d-inline-flex align-items-center justify-content-center text-secondary-emphasis pt-4 opacity-50">
                                            <SvgIcon icon={arrowRightIcon} style={{ width: "22px", height: "22px" }} />
                                        </span>
                                    )}
                                </div>
                            ))}
                        </div>

                        <h2 className="h4 fw-bold mb-3 text-body">No scenarios available to compare</h2>
                        <p className="mb-4 text-body-secondary" style={{ maxWidth: "540px", lineHeight: 1.6 }}>
                            Scenarios are generated and saved from Simulator. Once saved, they will appear here for comparison and evaluation.
                        </p>

                        <Button
                            themeColor="success"
                            rounded="medium"
                            svgIcon={playIcon}
                            className="fw-bold px-3 py-2 d-inline-flex align-items-center gap-2"
                            onClick={handleGoToSimulator}
                        >
                            Go to Simulator
                        </Button>

                        <Button
                            fillMode="flat"
                            themeColor="success"
                            className="fw-bold mt-3 px-3"
                        >
                            Learn how Scenarios work
                        </Button>
                    </div>
                </CardBody>
            </Card>
        </div>
    );
};

export default EmptyScenarios;
